import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CustomRole {
  id: string;
  deptId: string;
  title: string;
  capacity: number;
  createdAt: number;
}

interface CustomOrgState {
  customRoles: CustomRole[];
  /** override de logo por cliente — dataUrl/base64 */
  clientLogos: Record<string, string>;
  createRole: (deptId: string, title: string, capacity: number) => string;
  updateRole: (id: string, patch: Partial<CustomRole>) => void;
  removeRole: (id: string) => void;
  setClientLogo: (clientId: string, dataUrl: string) => void;
  clearClientLogo: (clientId: string) => void;
}

const uid = () => "c" + Math.random().toString(36).slice(2, 10);

export const useCustomOrg = create<CustomOrgState>()(
  persist(
    (set) => ({
      customRoles: [],
      clientLogos: {},
      createRole: (deptId, title, capacity) => {
        const id = uid();
        set(s => ({
          customRoles: [...s.customRoles, {
            id, deptId, title, capacity: Math.max(1, capacity),
            createdAt: Date.now()
          }]
        }));
        return id;
      },
      updateRole: (id, patch) => set(s => ({
        customRoles: s.customRoles.map(r => r.id === id ? { ...r, ...patch } : r)
      })),
      removeRole: (id) => set(s => ({
        customRoles: s.customRoles.filter(r => r.id !== id)
      })),
      setClientLogo: (clientId, dataUrl) => set(s => ({
        clientLogos: { ...s.clientLogos, [clientId]: dataUrl }
      })),
      clearClientLogo: (clientId) => set(s => {
        const next = { ...s.clientLogos };
        delete next[clientId];
        return { clientLogos: next };
      })
    }),
    { name: "agencia-vpc-customorg-v1" }
  )
);
